import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 30 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.55, delay, ease: "easeOut" }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ badge, title, sub, align = "center" }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} mb-12 sm:mb-16`}>
    {badge && (
      <span className="inline-block text-xs font-mono font-medium uppercase tracking-widest text-primary bg-primary/10 border border-primary/20 rounded-full px-4 py-1.5 mb-5">
        {badge}
      </span>
    )}
    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">{title}</h2>
    {sub && <p className="mt-4 text-base sm:text-lg text-muted-foreground leading-relaxed">{sub}</p>}
  </Reveal>
);
